module.exports = __webpack_public_path__ + "media/front/images/facebook-c6cf25dfd104eacca3aa5d3f2155d0f0.svg";